import { gql } from '@edreamsodigeo/frontend-api-client';

export const FLEXIBLE_DATES = gql`
  query flexibleDates($flexibleDatesSearchRequest: FlexibleDatesSearchRequest) {
    flexibleDates(flexibleDatesSearchRequest: $flexibleDatesSearchRequest) {
      originGeoNode
      destinationGeoNode
      firstOriginDate
      lastOriginDate
      firstReturnDate
      lastReturnDate
      numberOfRows
      numberOfColumns
      matrixEntries {
        ... on FlexibleDatesMatrixData {
          matrixRow
          matrixColumn
          departureDate
          returnDate
          apparentPrices {
            ... on FlexibleDatesApparentPrice {
              apparentPrice {
                ... on Money {
                  amount
                  currency
                }
              }
              apparentPriceCriteria
            }
          }
        }
      }
    }
  }
`;
